import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Table as AbyssTable } from '@uhg-abyss/web/ui/Table';
import React from 'react';

/**
 * Table
 *
 * Data containing date/time information about a risk record.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function Table({ data = {} }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/Dates/components/Table/Table.jsx">
      <div className="static-table">
        <AbyssTable.Container title="">
          <AbyssTable.TableBody>
            <AbyssTable.Row>
              <AbyssTable.Column>Stream Received</AbyssTable.Column>
              <AbyssTable.Cell>{dayjs(data?.streamReceived).format('MM/DD/YYYY, HH:mm:ss')}</AbyssTable.Cell>
            </AbyssTable.Row>

            <AbyssTable.Row>
              <AbyssTable.Column>Last Modified Date</AbyssTable.Column>
              <AbyssTable.Cell>{dayjs(data?.lastModifiedDate).format('MM/DD/YYYY, HH:mm:ss')}</AbyssTable.Cell>
            </AbyssTable.Row>

            <AbyssTable.Row>
              <AbyssTable.Column>Created Date</AbyssTable.Column>
              <AbyssTable.Cell>{dayjs(data?.createdDate).format('MM/DD/YYYY, HH:mm:ss')}</AbyssTable.Cell>
            </AbyssTable.Row>

            <AbyssTable.Row>
              <AbyssTable.Column>Replay Stream Received</AbyssTable.Column>
              <AbyssTable.Cell>{dayjs(data?.replayStreamReceived).format('MM/DD/YYYY, HH:mm:ss')}</AbyssTable.Cell>
            </AbyssTable.Row>
          </AbyssTable.TableBody>
        </AbyssTable.Container>
      </div>
    </ErrorHandler>
  );
}
